import React from 'react';

import SignInOrSignUpPageUI from './shared/SignInOrSignUpPageUI';
import { translatorForNamespace } from '../../../lib/TranslationManager';

const t = translatorForNamespace('SignUpPageUI');

const SignUpPageUI = ({
  error,
  email,
  password,
  onEmailChange = () => {},
  onPasswordChange = () => {},
  onSubmit = () => {},
  onFacebookSignIn = () => {},
  onGoogleSignIn = () => {},
  onBack = () => {},
}) => (
  <SignInOrSignUpPageUI
    {...{
      error,
      email,
      password,
      onEmailChange,
      onPasswordChange,
      onSubmit,
      onFacebookSignIn,
      onGoogleSignIn,
      title: t('Sign up'),
      dividerText: t('or sign up with'),
      onBack,
    }}
  />
);

export default SignUpPageUI;
